{
  "role": {
    "notAllowed": "You do not have the appropriate permissions"
  }
}
